/**
 * Generated by orval v6.28.2 🍺
 * Do not edit manually.
 * Maybern
 * Maybern API
 * OpenAPI spec version: 0.0.0
 */
import {
  useMutation,
  useQuery,
  useSuspenseQuery
} from '@tanstack/react-query'
import type {
  MutationFunction,
  QueryFunction,
  QueryKey,
  UseMutationOptions,
  UseQueryOptions,
  UseQueryResult,
  UseSuspenseQueryOptions,
  UseSuspenseQueryResult
} from '@tanstack/react-query'
import type {
  BorrowingBaseToInvestorEntitiesEditAPIDataRequest
} from '../../model/borrowingBaseToInvestorEntitiesEditAPIDataRequest'
import type {
  BorrowingBaseVersionUpsertDataRequest
} from '../../model/borrowingBaseVersionUpsertDataRequest'
import type {
  CreditFacilityBorrowingBaseGroupWithCountData
} from '../../model/creditFacilityBorrowingBaseGroupWithCountData'
import type {
  CreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveParams
} from '../../model/creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveParams'
import type {
  CreditFacilityBorrowingBaseToInvestorEntitiesUpdateParams
} from '../../model/creditFacilityBorrowingBaseToInvestorEntitiesUpdateParams'
import type {
  CreditFacilityBorrowingBaseVersionRetrieveParams
} from '../../model/creditFacilityBorrowingBaseVersionRetrieveParams'
import type {
  GenericTableData
} from '../../model/genericTableData'
import { axiosRequest } from '../../../shared/api/Api';


      
type SecondParameter<T extends (...args: any) => any> = Parameters<T>[1];



      import { appQueryClient } from "app/AppQueryClient";
      import { LoaderFunction, Params } from "@remix-run/router";
      import { isLoggedIn } from "axios-jwt";

      const authedLoader = (loader: LoaderFunction): LoaderFunction =>
        async (args) => {
          const result = await isLoggedIn();
          if (result) {
            return loader(args);
          }
          return null;
        };
    /**
 * Retrieve a table of investor entities associated to a borrowing base group
 */
export const creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    params?: CreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<GenericTableData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility-borrowing-base-investors/${creditFacilityId}/${borrowingBaseGroupId}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    params?: CreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility-borrowing-base-investors/${creditFacilityId}/${borrowingBaseGroupId}`, ...(params ? [params]: [])] as const;
    }

    
export const getCreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    params?: CreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId,borrowingBaseGroupId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>> = ({ signal }) => creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve(fundFamilyId,creditFacilityId,borrowingBaseGroupId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && borrowingBaseGroupId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>>
export type CreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveQueryError = unknown

export const useCreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    params?: CreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveQueryOptions(fundFamilyId,creditFacilityId,borrowingBaseGroupId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    params?: CreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId,borrowingBaseGroupId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>> = ({ signal }) => creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve(fundFamilyId,creditFacilityId,borrowingBaseGroupId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && borrowingBaseGroupId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>>
export type CreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveSuspenseQueryError = unknown

export const useCreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    params?: CreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,borrowingBaseGroupId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveLoader = (queryParamsOrFn?: (CreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveParams | ((params: Params) => CreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,borrowingBaseGroupId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,borrowingBaseGroupId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && creditFacilityId && borrowingBaseGroupId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieveQueryKey(fundFamilyId,creditFacilityId,borrowingBaseGroupId, queryParams),
              queryFn: () => creditFacilityBorrowingBaseInvestorEntitiesTableDataRetrieve(fundFamilyId,creditFacilityId,borrowingBaseGroupId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Adds investor entities to a borrowing base group
 */
export const creditFacilityBorrowingBaseToInvestorEntitiesUpdate = (
    fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    borrowingBaseToInvestorEntitiesEditAPIDataRequest: BorrowingBaseToInvestorEntitiesEditAPIDataRequest,
    params?: CreditFacilityBorrowingBaseToInvestorEntitiesUpdateParams,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/credit-facility-borrowing-base-investors/${creditFacilityId}/${borrowingBaseGroupId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: borrowingBaseToInvestorEntitiesEditAPIDataRequest,
        params
    },
      options);
    }
  


export const getCreditFacilityBorrowingBaseToInvestorEntitiesUpdateMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseToInvestorEntitiesUpdate>>, TError,{fundFamilyId: string;creditFacilityId: string;borrowingBaseGroupId: string;data: BorrowingBaseToInvestorEntitiesEditAPIDataRequest;params?: CreditFacilityBorrowingBaseToInvestorEntitiesUpdateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseToInvestorEntitiesUpdate>>, TError,{fundFamilyId: string;creditFacilityId: string;borrowingBaseGroupId: string;data: BorrowingBaseToInvestorEntitiesEditAPIDataRequest;params?: CreditFacilityBorrowingBaseToInvestorEntitiesUpdateParams}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityBorrowingBaseToInvestorEntitiesUpdate>>, {fundFamilyId: string;creditFacilityId: string;borrowingBaseGroupId: string;data: BorrowingBaseToInvestorEntitiesEditAPIDataRequest;params?: CreditFacilityBorrowingBaseToInvestorEntitiesUpdateParams}> = (props) => {
          const {fundFamilyId,creditFacilityId,borrowingBaseGroupId,data,params} = props ?? {};

          return  creditFacilityBorrowingBaseToInvestorEntitiesUpdate(fundFamilyId,creditFacilityId,borrowingBaseGroupId,data,params,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityBorrowingBaseToInvestorEntitiesUpdateMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityBorrowingBaseToInvestorEntitiesUpdate>>>
    export type CreditFacilityBorrowingBaseToInvestorEntitiesUpdateMutationBody = BorrowingBaseToInvestorEntitiesEditAPIDataRequest
    export type CreditFacilityBorrowingBaseToInvestorEntitiesUpdateMutationError = unknown

    export const useCreditFacilityBorrowingBaseToInvestorEntitiesUpdate = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseToInvestorEntitiesUpdate>>, TError,{fundFamilyId: string;creditFacilityId: string;borrowingBaseGroupId: string;data: BorrowingBaseToInvestorEntitiesEditAPIDataRequest;params?: CreditFacilityBorrowingBaseToInvestorEntitiesUpdateParams}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityBorrowingBaseToInvestorEntitiesUpdateMutationOptions(options);

      return useMutation(mutationOptions);
    }
    /**
 * Gets a borrowing base version
 */
export const creditFacilityBorrowingBaseVersionRetrieve = (
    fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    params?: CreditFacilityBorrowingBaseVersionRetrieveParams,
 options?: SecondParameter<typeof axiosRequest>,signal?: AbortSignal
) => {
      
      
      return axiosRequest<CreditFacilityBorrowingBaseGroupWithCountData>(
      {url: `/fund-family/${fundFamilyId}/credit-facility-borrowing-base-investors/${creditFacilityId}/version/${borrowingBaseGroupId}`, method: 'GET',
        params, signal
    },
      options);
    }
  

export const getCreditFacilityBorrowingBaseVersionRetrieveQueryKey = (fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    params?: CreditFacilityBorrowingBaseVersionRetrieveParams,) => {
    return [`/fund-family/${fundFamilyId}/credit-facility-borrowing-base-investors/${creditFacilityId}/version/${borrowingBaseGroupId}`, ...(params ? [params]: [])] as const;
    }

    
export const getCreditFacilityBorrowingBaseVersionRetrieveQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    params?: CreditFacilityBorrowingBaseVersionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityBorrowingBaseVersionRetrieveQueryKey(fundFamilyId,creditFacilityId,borrowingBaseGroupId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>> = ({ signal }) => creditFacilityBorrowingBaseVersionRetrieve(fundFamilyId,creditFacilityId,borrowingBaseGroupId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && borrowingBaseGroupId), ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityBorrowingBaseVersionRetrieveQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>>
export type CreditFacilityBorrowingBaseVersionRetrieveQueryError = unknown

export const useCreditFacilityBorrowingBaseVersionRetrieve = <TData = Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    params?: CreditFacilityBorrowingBaseVersionRetrieveParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityBorrowingBaseVersionRetrieveQueryOptions(fundFamilyId,creditFacilityId,borrowingBaseGroupId,params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



export const getCreditFacilityBorrowingBaseVersionRetrieveSuspenseQueryOptions = <TData = Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>, TError = unknown>(fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    params?: CreditFacilityBorrowingBaseVersionRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getCreditFacilityBorrowingBaseVersionRetrieveQueryKey(fundFamilyId,creditFacilityId,borrowingBaseGroupId,params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>> = ({ signal }) => creditFacilityBorrowingBaseVersionRetrieve(fundFamilyId,creditFacilityId,borrowingBaseGroupId,params, requestOptions, signal);

      

      

   return  { queryKey, queryFn, enabled: !!(fundFamilyId && creditFacilityId && borrowingBaseGroupId), ...queryOptions} as UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>, TError, TData> & { queryKey: QueryKey }
}

export type CreditFacilityBorrowingBaseVersionRetrieveSuspenseQueryResult = NonNullable<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>>
export type CreditFacilityBorrowingBaseVersionRetrieveSuspenseQueryError = unknown

export const useCreditFacilityBorrowingBaseVersionRetrieveSuspense = <TData = Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>, TError = unknown>(
 fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    params?: CreditFacilityBorrowingBaseVersionRetrieveParams, options?: { query?:Partial<UseSuspenseQueryOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionRetrieve>>, TError, TData>>, request?: SecondParameter<typeof axiosRequest>}

  ):  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey } => {

  const queryOptions = getCreditFacilityBorrowingBaseVersionRetrieveSuspenseQueryOptions(fundFamilyId,creditFacilityId,borrowingBaseGroupId,params,options)

  const query = useSuspenseQuery(queryOptions) as  UseSuspenseQueryResult<TData, TError> & { queryKey: QueryKey };

  query.queryKey = queryOptions.queryKey ;

  return query;
}



 
      export const getCreditFacilityBorrowingBaseVersionRetrieveLoader = (queryParamsOrFn?: (CreditFacilityBorrowingBaseVersionRetrieveParams | ((params: Params) => CreditFacilityBorrowingBaseVersionRetrieveParams)), paramsOrFn?: (Params | ((params: Params) => ({ fundFamilyId: string,creditFacilityId: string,borrowingBaseGroupId: string })))): LoaderFunction =>
        authedLoader(({ params }) => {
          const { fundFamilyId,creditFacilityId,borrowingBaseGroupId } = (typeof paramsOrFn === "function" ? paramsOrFn(params) : paramsOrFn) ?? params;
const queryParams = typeof queryParamsOrFn === "function" ? queryParamsOrFn(params) : queryParamsOrFn;
          if (fundFamilyId && creditFacilityId && borrowingBaseGroupId) {
            return appQueryClient.prefetchQuery({
              queryKey: getCreditFacilityBorrowingBaseVersionRetrieveQueryKey(fundFamilyId,creditFacilityId,borrowingBaseGroupId, queryParams),
              queryFn: () => creditFacilityBorrowingBaseVersionRetrieve(fundFamilyId,creditFacilityId,borrowingBaseGroupId, queryParams),
            }).then(() => null);
          }
          return null;
        });
      /**
 * Updates a borrowing base group version with data and investor entities
 */
export const creditFacilityBorrowingBaseVersionEdit = (
    fundFamilyId: string,
    creditFacilityId: string,
    borrowingBaseGroupId: string,
    borrowingBaseVersionUpsertDataRequest: BorrowingBaseVersionUpsertDataRequest,
 options?: SecondParameter<typeof axiosRequest>,) => {
      
      
      return axiosRequest<void>(
      {url: `/fund-family/${fundFamilyId}/credit-facility-borrowing-base-investors/${creditFacilityId}/version/${borrowingBaseGroupId}`, method: 'POST',
      headers: {'Content-Type': 'application/json', },
      data: borrowingBaseVersionUpsertDataRequest
    },
      options);
    }
  


export const getCreditFacilityBorrowingBaseVersionEditMutationOptions = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionEdit>>, TError,{fundFamilyId: string;creditFacilityId: string;borrowingBaseGroupId: string;data: BorrowingBaseVersionUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
): UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionEdit>>, TError,{fundFamilyId: string;creditFacilityId: string;borrowingBaseGroupId: string;data: BorrowingBaseVersionUpsertDataRequest}, TContext> => {
const {mutation: mutationOptions, request: requestOptions} = options ?? {};

      


      const mutationFn: MutationFunction<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionEdit>>, {fundFamilyId: string;creditFacilityId: string;borrowingBaseGroupId: string;data: BorrowingBaseVersionUpsertDataRequest}> = (props) => {
          const {fundFamilyId,creditFacilityId,borrowingBaseGroupId,data} = props ?? {};

          return  creditFacilityBorrowingBaseVersionEdit(fundFamilyId,creditFacilityId,borrowingBaseGroupId,data,requestOptions)
        }

        


  return  { mutationFn, ...mutationOptions }}

    export type CreditFacilityBorrowingBaseVersionEditMutationResult = NonNullable<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionEdit>>>
    export type CreditFacilityBorrowingBaseVersionEditMutationBody = BorrowingBaseVersionUpsertDataRequest
    export type CreditFacilityBorrowingBaseVersionEditMutationError = unknown

    export const useCreditFacilityBorrowingBaseVersionEdit = <TError = unknown,
    TContext = unknown>(options?: { mutation?:UseMutationOptions<Awaited<ReturnType<typeof creditFacilityBorrowingBaseVersionEdit>>, TError,{fundFamilyId: string;creditFacilityId: string;borrowingBaseGroupId: string;data: BorrowingBaseVersionUpsertDataRequest}, TContext>, request?: SecondParameter<typeof axiosRequest>}
) => {

      const mutationOptions = getCreditFacilityBorrowingBaseVersionEditMutationOptions(options);

      return useMutation(mutationOptions);
    }
    